import { useState, useCallback } from 'react';
import { importesPersonalAPI, pagoPorEstudioAPI } from '../../../core/api/api';

const ROLES = [
  { id: '2', rol: 'Técnico', esTecnico: true },
  { id: '1', rol: 'Médico', esTecnico: false },
];

export const useImportesPersonal = () => {
  const [importes, setImportes] = useState([]);
  const [personal, setPersonal] = useState([]);
  const [tiposEstudios, setTiposEstudios] = useState([]);
  const [centros, setCentros] = useState([]);
  const [pagos, setPagos] = useState([]);
  const [loading, setLoading] = useState(false);

  const cargarFiltros = useCallback(async (esTecnico) => {
    setLoading(true);
    try {
      const [pRes, tRes, cRes, pagosRes] = await Promise.all([
        importesPersonalAPI.getPersonal(esTecnico),
        pagoPorEstudioAPI.getTiposEstudios(),
        pagoPorEstudioAPI.getCentros(),
        pagoPorEstudioAPI.getPagos(null, esTecnico),
      ]);
      setPersonal(pRes.data || []);
      setTiposEstudios(tRes.data || []);
      setCentros(cRes.data || []);
      setPagos(pagosRes.data || []);
    } finally {
      setLoading(false);
    }
  }, []);

  const buscar = useCallback(async (idTipoEstudio, idPersona, esTecnico) => {
    setLoading(true);
    try {
      const res = await importesPersonalAPI.getImportes(idTipoEstudio, idPersona, esTecnico);
      setImportes(res.data || []);
    } finally {
      setLoading(false);
    }
  }, []);

  const guardar = useCallback(async (data) => {
    setLoading(true);
    try { await importesPersonalAPI.guardar(data); }
    finally { setLoading(false); }
  }, []);

  const actualizar = useCallback(async (id, data) => {
    setLoading(true);
    try { await importesPersonalAPI.actualizar(id, data); }
    finally { setLoading(false); }
  }, []);

  const eliminar = useCallback(async (id, esTecnico) => {
    setLoading(true);
    try { await importesPersonalAPI.eliminar(id, esTecnico); }
    finally { setLoading(false); }
  }, []);

  return { importes, personal, tiposEstudios, centros, pagos, roles: ROLES, loading, cargarFiltros, buscar, guardar, actualizar, eliminar };
};
